import { render } from "./OurFeedback.vue?vue&type=template&id=695bf75f"
import script from "./OurFeedback.vue?vue&type=script&lang=js"
export * from "./OurFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__